import { REQUEST_CLIENTS, RECEIVE_CLIENTS } from '../lib/actions';
import {
  CLIENTS,
  CLIENTS_PAGINATION,
  CLIENTS_STATISTIC
} from '../lib/storageVariables';
import { getLocalStorage, setLocalStorage } from '../lib/functions';

const STATE = {
  isFetching: false,
  items: getLocalStorage(CLIENTS) || [],
  pagination: getLocalStorage(CLIENTS_PAGINATION) || [],
  stats: getLocalStorage(CLIENTS_STATISTIC) || {}
};

export default function(state = STATE, action) {
  switch (action.type) {
    case REQUEST_CLIENTS:
      return {
        ...state,
        isFetching: true
      };

    case RECEIVE_CLIENTS:
      const clients = action.response.data;
      const { pagination, stats } = action.response.meta;

      if (clients) setLocalStorage(CLIENTS, clients);
      if (pagination) setLocalStorage(CLIENTS_PAGINATION, pagination);
      if (stats) setLocalStorage(CLIENTS_STATISTIC, stats);

      return {
        ...state,
        isFetching: false,
        items: clients || state.items,
        pagination: pagination || state.pagination,
        stats: stats || state.stats
      };

    default:
      return state;
  }
}
